"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NavDivider: function() {
        return _index.NavDivider;
    },
    navDividerClassNames: function() {
        return _index.navDividerClassNames;
    },
    useNavDividerStyles_unstable: function() {
        return _index.useNavDividerStyles_unstable;
    },
    useNavDivider_unstable: function() {
        return _index.useNavDivider_unstable;
    }
});
const _index = require("./components/NavDivider/index");
